import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
@Injectable()
export class SellerBOEService {

  constructor(private http: Http, private router: Router) { }

  public createBOE(boeData,buyerName) {
    const buyerId = localStorage.getItem('buyerId');
    const data = {
      'invoiceId': boeData.invoiceId,
      'paymentTerms': boeData.paymentTerms,
      'toAddress': buyerName
    };
    console.log('data', data);
    const body = JSON.stringify(data);
    console.log(body);
    return this.http.post(environment.baseUrl + '/seller/boe', body, GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
 
  public getMIBOEHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('MIViewBOECustomerId');
    const BOEinvoiceFlag = sessionStorage.getItem('MIViewBOEinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + BOEinvoiceFlag + '/billOfExchange',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public getBOEHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('sellerBOECustomerId');
    const BOEinvoiceFlag = sessionStorage.getItem('sellerBOEinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + BOEinvoiceFlag + '/billOfExchange',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public getMIOtherHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('MIViewOtherCustomerId');
    const MIinvoiceFlag = sessionStorage.getItem('MIViewOtherinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + MIinvoiceFlag + '/others',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }

  public getOtherHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('sellerViewOtherCustomerId');
    const BOEinvoiceFlag = sessionStorage.getItem('sellerViewOtherinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + BOEinvoiceFlag + '/others',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
  public  OnMILRUpload(Image, fileId) {
    console.log('image', Image);
    const sellerId = sessionStorage.getItem('MILRCustomerId');
    const manualInvoiceFlag = sessionStorage.getItem('MILRinvoiceFlag');
    const formData: FormData = new FormData();
    formData.append('invoiceId', fileId);
    formData.append('lorryReceipt', Image);
    formData.append('manualInvoice', manualInvoiceFlag);
    formData.append('sellerId', sellerId);
    console.log('formdata', formData);
    return this.http.post(environment.docUrl + '/swarm/upload_docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public  OnLRUpload(Image, fileId) {
    console.log('image', Image);
    const sellerId = sessionStorage.getItem('LRsellerId');
    const manualInvoiceFlag = sessionStorage.getItem('LRinvoiceFlag');
    const formData: FormData = new FormData();
    formData.append('invoiceId', fileId);
    formData.append('lorryReceipt', Image);
    formData.append('manualInvoice', manualInvoiceFlag);
    formData.append('sellerId', sellerId);
    console.log('formdata', formData);
    return this.http.post(environment.docUrl + '/swarm/upload_docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public  OnBOEUpload(Image, fileId) {
    console.log('image', Image);
    const sellerId = sessionStorage.getItem('MIBOECustomerId');
    const manualInvoiceFlag = sessionStorage.getItem('MIBOEinvoiceFlag');
    const formData: FormData = new FormData();
    formData.append('billOfExchange', Image);
    formData.append('invoiceId', fileId);
    formData.append('manualInvoice', manualInvoiceFlag);
    formData.append('sellerId', sellerId);
    console.log('formdata', formData);
    return this.http.post( environment.docUrl + '/swarm/upload_docs', formData).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    });
  }

  public getLRHash(fileId) {
    console.log('inside services');
    const invoiceId = fileId;
    const sellerId = sessionStorage.getItem('MIViewLRCustomerId');
    const LRinvoiceFlag = sessionStorage.getItem('MIViewLRinvoiceFlag');
    return this.http.get(environment.docUrl + '/swarm/docs/' + sellerId + '/' + invoiceId + '/' + LRinvoiceFlag + '/lorryReceipt',
    GlobalService.getHeaders()).map((response: Response) => {
      console.log(response.status);
      const user = response.json();
      user.responseStatus = response.status;
      console.log(user);
      return user;
    }).catch((error) => {
      console.log('error', error);
      if (error.status === 500) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 400) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      } else if (error.status === 401) {
        console.log('status', error.status);
        const err = error.json();
        err.responseStatus = error.status;
        console.log('status', err.responseStatus);
        return Observable.throw(err);
      }
  });
  }
}
